import { gql } from '@apollo/client'

export const SessionUserGroupErrorsFragment = gql`
  fragment SessionUserGroupErrorsFragment on AuthMutationError {
    message
    type
  }
`
